import { Component, OnInit } from "@angular/core";
import * as $ from "jquery";
import { CAPService } from "../../core/services/cap-service";
import { Router, ActivatedRoute } from "@angular/router";
import { PagerService } from "../../core/services/pager.service";
import { IDropdownSettings } from "ng-multiselect-dropdown";
//import { toBase64String } from "@angular/compiler/src/output/source_map";
import * as CryptoJS from "crypto-js";
import { GridOptions } from "ag-grid-community";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

@Component({
  selector: "app-add-auth-level",
  templateUrl: "./add-auth-level.component.html",
  styleUrls: ["./add-auth-level.component.css"],
})
export class AddAuthLevelComponent implements OnInit {
  public Authlvl;
  dynamicVariable = true;
  AuthlvlList: any[];
  LocationList: any[];
  Authlvls: any[];
  FacilityList: any[];
  CountryList: any[];
  Countries: any[];
  Facilities: any[];
  MultiSelectCountriesTeams;
  MultiSelectLocationList;
  Locations: any[];
  updateFacilities: any[];
  successfulData;
  model;
  AuthlvlDetails;
  Device;
  public loaderGif: boolean;
  formAuthlvl;
  DeviceTypeList;
  dataLoader: boolean;
  pager: any = {};
  private allItems: any[];
  pagedItems: any[];
  public dropDownSettings: IDropdownSettings;
  public country = "";
  public Type = "";
  public Country = "";
  public Location = "";
  public Facility = "";
  public DeviceType;
  public _Country;
  // public setPage;
  public authlvl: any[];
   counSelected:Number;
  public SelectedLocation = [];
  public SelectedFacility = [];
  public SelCity = [];
  public SelectedAuthlvl = [];
  public SelectedCountry = [];
  public Role = "";
  public LoginEnterpriseID = "";
  public divLocation;
  public divFacility;
  public divAuthlvl;
  IsLabel : boolean;

  public customDrpDwnSettings: IDropdownSettings = {
    itemsShowLimit: 1,
    idField: "label_id",
    allowSearchFilter: true,
    textField: "label_text",
    selectAllText: "Check All",
    unSelectAllText: "UnCheck All",
    maxHeight: 100,
    searchPlaceholderText: "Search",
    clearSearchFilter: true,
  };

  constructor(
    private router: Router,
    private capservice: CAPService,
    private _avRoute: ActivatedRoute,
    private pagerService: PagerService
  ) {
    this.LoginEnterpriseID = capservice.enterpriseid;
    this.Role = capservice.Role;
    this.Country = capservice.country;
    this._Country = capservice.country;

    if (this.Role == "Regional Voice Admin") {
      this.country = this.Country;
      this.Type = "Regional";
    } else if (this.Role == undefined) {
      // $location.path("/LoginInvalid");
      // $route.reload();
    } else {
      this.country = "N";
      this.Type = "N";
    }
  }

  ngOnInit() {
    // if(this.Role =="Regional Voice Admin" || this.Role =="Global Admin")
    // {
      
    //   this.GetCountryListDropDown();
    // this.GetAuthlvlListDropDown();
    // this.SearchFacilityListDropDown();
    // this.GetFacilityListDropDown();
    
    // $("#divAuthlvlDetailsCommon").css("display", "block");
    // $("#divAuthlvlSubmit").css("display", "block");
    // $("#divAuthlvlDetails").css("display", "block");
    // $("#AlertForAccesslevel").css("display", "none");
    // this.LoadData();
    // }
    // else
    // {
    //   $("#divAuthlvlDetailsCommon").css("display", "none");
    //   $("#divAuthlvlSubmit").css("display", "none");
    //   $("#divAuthlvlDetails").css("display", "none");
    //   $("#AlertForAccesslevel").css("display", "block");
    // }
    // this.dataLoader = false;

    this.dropDownSettings = {
      itemsShowLimit: 1,
      idField: "label_id",
      allowSearchFilter: true,
      textField: "label",
      selectAllText: "Check All",
      unSelectAllText: "UnCheck All",
      maxHeight: 100,
      searchPlaceholderText: "Search",
      clearSearchFilter: true,
      noDataAvailablePlaceholderText: "No data available",
    };
    this.AuthlvlDetails = {
      SlNo: "",
      AuthorizationLevel: "",
      Country: "",
      Location: "",
      City: "",
      strType: "",
    };
    this.successfulData = {
      Id: "",
      SlNo: "",
      AuthorizationLevel: "",
      Country: "",
      Location: "",
      City: "",
      strType: "",
    };
    
      this.GetCountryListDropDown();
    this.GetAuthlvlListDropDown();
    this.SearchFacilityListDropDown();
    this.GetFacilityListDropDown();
    
    $("#divAuthlvlDetailsCommon").css("display", "block");
    $("#divAuthlvlSubmit").css("display", "block");
    $("#divAuthlvlDetails").css("display", "block");
    $("#AlertForAccess").css("display", "none");
    this.LoadData();


    this.AudiLogin();
    this.AuthlvlDetails.Country = "India";
  }
  AudiLogin() {
    this.capservice
      .AudiLogin("Authlvl", this.LoginEnterpriseID)
      .subscribe((data) => {});
  }
  GetCountryListDropDown() {
    this.capservice.CountryList(this.country, this.Type).subscribe((data) => {
      this.Countries = data;
    });
  }
  GetAuthlvlListDropDown() {
    this.capservice
      .GatewayList(null, "AuthlvlDropdown", null)
      .subscribe((data) => {
        this.AuthlvlList = data;
       var MultiCountryTypeObj = { MultiCountryTypeArray: [] };
      for (var i = 0; i < data.length; i++) {
        var CountryType = { label_id: i, label: data[i].AuthorizationLevel }
          MultiCountryTypeObj.MultiCountryTypeArray.push(CountryType);
        }
        this.AuthlvlList = MultiCountryTypeObj.MultiCountryTypeArray;
      });
  }
  GetLocationListDropDown(City) {
    debugger;
    this.capservice.CountryList(City, "LocationDropdown").subscribe((data) => {
      this.LocationList = data;
    });
  }
  GetFacilityListDropDown() {
    this.capservice.FacilityList("Location").subscribe((data) => {
      this.Facilities = data;
    });
  }
  SearchFacilityListDropDown() {
    this.capservice.FacilityList("Location").subscribe((data) => {
      this.MultiSelectCountriesTeams = data;
    var MultiCountryTypeObj = { MultiCountryTypeArray: [] };
      for (var i = 0; i < data.length; i++) {
        var CountryType = { label_id: i, label: data[i].City }
        MultiCountryTypeObj.MultiCountryTypeArray.push(CountryType);
      }
      this.MultiSelectCountriesTeams =
        MultiCountryTypeObj.MultiCountryTypeArray;
    });
  }

  SearchLocation() {
    debugger;
  var MultiLocation = ''; 
  var City = '';
    this.SelectedLocation = [];
    this.MultiSelectLocationList = [];

    //this.SelCity = CityList;
  for (var i = 0; i < this.SelectedFacility.length; i++) {
    MultiLocation = MultiLocation + ',' + this.SelectedFacility[i].label;
    }
    City = MultiLocation.slice(1, MultiLocation.length);

    this.capservice.CountryList(City, "LocationDropdown").subscribe((data) => {
      this.MultiSelectLocationList = data;
    var MultiCountryTypeObj = { MultiCountryTypeArray: [] };
      for (var i = 0; i < data.length; i++) {
        var CountryType = { label_id: i, label: data[i].Location }
        MultiCountryTypeObj.MultiCountryTypeArray.push(CountryType);
      }
      this.MultiSelectLocationList = MultiCountryTypeObj.MultiCountryTypeArray;
    });
  }
  SearchLocationAll(CityList) {
    debugger;
    var MultiLocation = ''; 
    var City = '';
    this.SelectedLocation = [];
    this.MultiSelectLocationList = [];

    this.SelectedFacility = CityList;
    for (var i = 0; i < this.SelectedFacility.length; i++) {
      MultiLocation = MultiLocation + ',' + this.SelectedFacility[i].label;
    }
    City = MultiLocation.slice(1, MultiLocation.length);

    this.capservice.CountryList(City, "LocationDropdown").subscribe((data) => {
      this.MultiSelectLocationList = data;
      var MultiCountryTypeObj = { MultiCountryTypeArray: [] };
        for (var i = 0; i < data.length; i++) {
          var CountryType = { label_id: i, label: data[i].Location }
        MultiCountryTypeObj.MultiCountryTypeArray.push(CountryType);
      }
      this.MultiSelectLocationList = MultiCountryTypeObj.MultiCountryTypeArray;
    });
  }

  onItemSelect(item: any) {
    this.SearchLocation();
  }
  onItemDeSelect(item: any) {
    this.SearchLocation();
  }
  onSelectAll(items: any) {
    this.SearchLocationAll(items);
  }
  onUnSelectAll(items: any) {
    this.SearchLocationAll(items);
  }
  validateNumber(e: any) {
  let input = String.fromCharCode(e.charCode);
    //const reg = /^(\d{1,5}|\d{0,5}\.\d{1,2})$/;
    const reg = /^([0-9:]*)$/;

    if (!reg.test(input)) {
      e.preventDefault();
    }
  }

  LoadData() {
    this.capservice
      .GatewayList(null, "Authorization", null)
      .subscribe((data) => {
        this.dataLoader = true;
        this.successfulData = { Authlvls: data, selected: {} };
        this.allItems = data;
        this.setPage(1);
        this.dataLoader = false;
      });
  }
  ShowData() {
    this.loaderGif = true;
    debugger;

    if ($("#dlstCountry").val() == "") {
      $("#divAuthlvlDetails").css("display", "none");
      alert("Please select country field");
          }
     else
     {
      var City = '';var Location = '';var AuthLevel = '';
      var SelCity  ='';var SelLocation =''; var SelAuthLevel = '';

      for (var i = 0; i < this.SelectedFacility.length; i++) {
        SelCity = SelCity + "," + this.SelectedFacility[i].label;
      }
      City = SelCity.slice(1, SelCity.length);

      for (var i = 0; i < this.SelectedLocation.length; i++) {
        SelLocation = SelLocation + "," + this.SelectedLocation[i].label;
      }
      Location = SelLocation.slice(1, SelLocation.length);

      for (var i = 0; i < this.SelectedAuthlvl.length; i++) {
        SelAuthLevel = SelAuthLevel + "," + this.SelectedAuthlvl[i].label;
      }
      AuthLevel = SelAuthLevel.slice(1, SelAuthLevel.length);

      this.capservice
        .SearchDetails(null, City, Location, AuthLevel, "AuthLevel")
        .subscribe((data) => {
          if (data.length > 0) {
            this.successfulData = { Authlvls: data, selected: {} };
            this.allItems = data;
            // initialize to page 1
            this.setPage(1);
            $("#divAuthlvlDetails").css("display", "block");
          } else {
            alert("No Records Found");
            this.clear();
            $("#divAuthlvlDetails").css("display", "none");
          }
        });
    }
  }
  ExportToBulkExcel() {
     var Country = '';
      var ReportName = 'AuthorizationLevel.xlsx';

      var City = '';var Location = '';var AuthLevel = '';
      var SelCity  ='';var SelLocation =''; var SelAuthLevel = '';

    for (var i = 0; i < this.SelectedFacility.length; i++) {
      SelCity = SelCity + "," + this.SelectedFacility[i].label;
    }
    City = SelCity.slice(1, SelCity.length);

    for (var i = 0; i < this.SelectedLocation.length; i++) {
      SelLocation = SelLocation + "," + this.SelectedLocation[i].label;
    }
    Location = SelLocation.slice(1, SelLocation.length);

    for (var i = 0; i < this.SelectedAuthlvl.length; i++) {
      SelAuthLevel = SelAuthLevel + "," + this.SelectedAuthlvl[i].label;
    }
    AuthLevel = SelAuthLevel.slice(1, SelAuthLevel.length);

    this.capservice
      .SearchDetailsBulkDownload(null, City, Location, AuthLevel, "AuthLevel")
      .subscribe(
        (data: Blob) => {
          this.dataLoader = true;
          if (data.size > 0) {
            if (
              window.navigator &&
              (window.navigator as any).msSaveOrOpenBlob
            ) {
              // for IE
              (window.navigator as any).msSaveOrOpenBlob(data, ReportName);
              this.dataLoader = false;
           }
             else{
               var link = document.createElement('a');
              link.href = window.URL.createObjectURL(data);
              link.download = ReportName;
              link.click();
              this.dataLoader = false;
            }
          } else {
            alert("No Records Found");
            this.dataLoader = false;
          }
        },
        function (x) {
          console.log(x);
          this.dataLoader = false;
          alert("Acknowledgement failed");
        }
      );
  }
  AuthlvlAdd() {
     var message = '';

    if (
      $("#grdfCountry").val() == "" ||
      $("#grdfLocation").val() == "" ||
      $("#grdfFacility").val() == "" ||
      $("#grdfAuthlvl").val() == ""
    ) {
      message = message + "\n" + "Please select mandatory fields";
    }

    if (message != "") {
      alert(message);
    } else {
      debugger;
      this.AuthlvlDetails.Country = "India";
      this.AuthlvlDetails.strType = "AuthLevel";

      this.capservice
        .InsertVoiceAdminDetails(this.AuthlvlDetails)
        .subscribe((data: any) => {
          if(data == "Inserted Successfully"){
            alert(data);
            this.clear();
          }
          else if(data == "BadRequest"){
            alert("Bad Request 404!");
          this.clear();
          }
          else{
            alert(data);
            this.clear();
          }
          
        });
    }
  }
  EditAuthlvl(Authlvl) {
    this.successfulData.selected = Object.assign({}, Authlvl);
    this.capservice
      .CountryList(this.successfulData.selected.City, "LocationDropdown")
      .subscribe((data) => {
        this.LocationList = data;
      });
  }
  AuthlvlUpdate(Authlvl) {
     var message = '';

    if (
      $("#grdCountry").val() == "" ||
      $("#grdFacility").val() == "" ||
      $("#grdLocation").val() == "" ||
      $("#grdAuthlvl").val() == ""
    ) {
      message = message + "\n" + "Please select mandatory fields";
    }
    //  if ($('#grdCountry').val() == '') {
    //    message = message + "\n" + "Please Select Country";
    //  }
    //  if ($('#grdFacility').val() == '') {
    //   message = message + "\n" + "Please Select Facility";
    // }
    //  if ($('#grdLocation').val() == '') {
    //    message = message + "\n" + "Please Select Location";
    //  }
    //  if ($('#grdAuthlvl').val() == '') {
    //    message = "Please Enter the Authorization Level";
    //  }
    if (message != "") {
      alert(message);
    } else {
      this.successfulData.selected.Id = this.successfulData.selected.SlNo;
      this.successfulData.selected.strType = "Authlvl";
      this.capservice
        .UpdateVoiceAdminDetails(this.successfulData.selected)
        .subscribe((data: any) => {
          // alert(data);
           this.clear();
           if(data == "Updated Successfully"){
              alert(data);
              this.clear();
          }
          if(data == "Data already exists"){
            alert(data);
            this.clear();
        }
           else if(data == "BadRequest"){
             alert("Bad Request 404!");
           this.clear();
           }
        });
    }
  }
  DeleteAuthlvl(Authlvl) {
    debugger;
    this.capservice
      .DeleteVoiceAdminDetails(
        Authlvl.SlNo,
        "Authlvl",
        this.LoginEnterpriseID,
        ""
      )
      .subscribe((data) => {
        alert(data);
        this.clear();
      });
  }

  clear() {
    this.SelectedFacility = [];
    this.SelectedLocation = [];
    this.SelectedAuthlvl = [];

    $("#grdfAuthlvl").val("");
    $("#grdfFacility").val("");
    //$('#grdfCountry').val('');
    $("#grdfLocation").val("");
    $("#grdAuthlvl").val("");
    $("#grdFacility").val("");
    $("#grdCountry").val("");
    $("#grdLocation").val("");

    $("#divAuthlvlDetails").css("display", "block");
    this.LoadData();
  }
  reset() {
    this.successfulData.selected = {};
  }
  setPage(page: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    // get pager object from service
    this.pager = this.pagerService.getPager(this.allItems.length, page, 5);
    // get current page of items
    this.successfulData.Authlvls = this.allItems.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
  }
}
